import { useState, useEffect, useRef } from "react";
import Overview from "./Overview";
import { getAllocations, setAllocationDone, setDoorsAndCompartments } from "../../../fetchApi";
import { setDoInterval } from "../../../utils";

export default function Allocations({ vehicle, onScrollReady }) {
  const [allocations, setAllocations] = useState(null);
  const [selectedAllocation, setSelectedAllocation] = useState(null);
  const hasScrolled = useRef(false);

  useEffect(() => {
    if (allocations !== null && !hasScrolled.current) {
      onScrollReady();
      hasScrolled.current = true;
    }
  }, [allocations, onScrollReady]);

  useEffect(() => {
    async function update() {
      const allocationsRes = await getAllocations(vehicle.id);
      setAllocations(allocationsRes.sort((a, b) => a.code - b.code));
    }

    const updateInterval = setDoInterval(
      () => update().catch((err) => console.error("allocations err:", err)),
      2000
    );

    return () => {
      clearInterval(updateInterval);
    };
  }, [vehicle.id]);

  function range(start, end) {
    return Array.from({ length: end - start }, (_, i) => start + i);
  }

  return (
    <>
      <div className="col-12">
        <Overview vehicleId={vehicle.id} highlight={selectedAllocation?.compartmentList} />
      </div>
      <div className="col-12">
        <table
          className="table table-striped table-bordered"
          style={{ width: 800, marginLeft: "auto", marginRight: "auto" }}
        >
          <thead>
            <tr>
              <th scope="col">Code</th>
              <th scope="col">Box / Compartments</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            {allocations?.map((allocation) => (
              <tr key={allocation.id}>
                <td>
                  <span style={{ fontWeight: "bold" }}>{allocation.code}</span>
                  <span style={{ fontStyle: "italic" }}>{allocation.done ? " (done)" : ""}</span>
                </td>
                <td>
                  {allocation.compartmentList
                    .map(
                      (compartment) =>
                        `Box ${compartment.boxIdx} / ${range(
                          compartment.fromCompartmentIdx,
                          compartment.toCompartmentIdx + 1
                        )
                          .map((x) => `C${x}`)
                          .join(", ")}`
                    )
                    .join(", ")}
                </td>
                <td>
                  <button
                    className={`btn btn-primary btn-sm${
                      selectedAllocation?.id === allocation.id ? " disabled" : ""
                    }`}
                    style={{ marginLeft: 4, marginRight: 4, pointerEvents: "auto" }}
                    onClick={() =>
                      setSelectedAllocation(
                        selectedAllocation?.id === allocation.id ? null : allocation
                      )
                    }
                  >
                    Show
                  </button>
                  <button
                    className="btn btn-success btn-sm"
                    style={{ marginLeft: 4, marginRight: 4 }}
                    onClick={() => setDoorsAndCompartments(vehicle.id, allocation.id, "open")}
                  >
                    Open
                  </button>
                  <button
                    className="btn btn-danger btn-sm"
                    style={{ marginLeft: 4, marginRight: 4 }}
                    onClick={() => setDoorsAndCompartments(vehicle.id, allocation.id, "close")}
                  >
                    Close
                  </button>
                  <button
                    className="btn btn-secondary btn-sm"
                    style={{ marginLeft: 4, marginRight: 4 }}
                    onClick={() => setAllocationDone(vehicle.id, allocation.id)}
                    disabled={allocation.done}
                  >
                    Mark done
                  </button>
                </td>
              </tr>
            ))}
            {allocations?.length > 0 ? null : (
              <tr>
                <td colSpan={3}>No allocations</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}
